/** 来源：foodbuy/market PageHeader；保留 eyebrow、标题、说明和操作位的同构签名。 */
import type { ReactNode } from 'react'

export function PageHeader({ eyebrow, title, description, action }: { eyebrow: ReactNode; title: ReactNode; description: ReactNode; action?: ReactNode }) {
  return (
    <header className="flex flex-wrap items-end justify-between gap-4">
      <div>
        <p className="m-0 text-xs font-bold text-[var(--color-primary)]">{eyebrow}</p>
        <h1 className="m-0 mt-1 text-2xl font-bold tracking-tight text-[var(--color-ink)]">{title}</h1>
        <span className="mt-1.5 block text-sm text-[var(--color-muted)]">{description}</span>
      </div>
      {action}
    </header>
  )
}
